import {
  ApiKey,
  useSnackbarNotification,
} from '@jupiterone/jupiter-web-toolkit';

import Key from '@jupiterone/react-brand-icons/jupiterone/class/Key';
import { CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { useBooleanState } from 'react-use-object-state';
import EditHeader from 'navbar/src/jupiterAccountSettings/AccountSettings/components/EditHeader';
import useSharedUsersAndAccountStyles from 'navbar/src/jupiterAccountSettings/AccountSettings/useSharedUsersAndAccountStyles';
import GeneratedApiKey from './GeneratedApiKey';
import NewApiKeyForm, { ApiKeyFormValues } from './NewApiKeyForm';
import useAPIKey from 'navbar/src/jupiterAccountSettings/hooks/useApiKey';

interface Props {
  onBackButtonClick: VoidFunction;
  onApiKeyCreated: (apiKey: ApiKey) => void;
}

const CreateNewApiKey = ({ onBackButtonClick, onApiKeyCreated }: Props) => {
  const sharedClasses = useSharedUsersAndAccountStyles();
  const notification = useSnackbarNotification();
  const { createApiKey } = useAPIKey();
  const creatingApiKey = useBooleanState(false);
  const [newApiKey, setNewApiKey] = useState<ApiKey | undefined>(undefined);

  const handleGenerateApiKey = async ({
    apiKeyName,
    expireInDays,
  }: ApiKeyFormValues) => {
    creatingApiKey.setTrue();
    try {
      const createdApiKey = await createApiKey(
        apiKeyName,
        parseInt(expireInDays, 10)
      );
      setNewApiKey(createdApiKey);
      onApiKeyCreated(createdApiKey);
    } catch (error) {
      notification.error({
        message: 'Error generating new api key.',
        error,
      });
    } finally {
      creatingApiKey.setFalse();
    }
  };

  if (creatingApiKey.state) {
    return (
      <div className={sharedClasses.centerXY}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <EditHeader
      handleBackButton={onBackButtonClick}
      titleText={newApiKey ? 'Your New API Key' : 'Create API Key'}
      titleIcon={<Key />}
    >
      {newApiKey ? (
        <GeneratedApiKey keyValue={newApiKey.key} />
      ) : (
        <NewApiKeyForm onSubmit={handleGenerateApiKey} />
      )}
    </EditHeader>
  );
};

export default CreateNewApiKey;
